import React, { useState } from "react";

const TextInput = ({
  label,
  type = "text",
  required,
  placeholder,
  value,
  onChange,
  disabled,
  id,
  errorFormik, // Keep it as an optional prop, but don’t log it unnecessarily
}) => {
  const [error, setError] = useState(errorFormik || ""); // Default to empty string if undefined

  const handleChange = (e) => {
    const inputValue = e.target.value;
    let errorMessage = "";

    if (required && !inputValue.trim()) {
      errorMessage = "Ce champ est obligatoire.";
    } else if (type === "email" && inputValue && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue)) {
      errorMessage = "Format d'email invalide.";
    } else if (type === "tel" && inputValue && !/^\+?[0-9]{7,15}$/.test(inputValue)) {
      errorMessage = "Numéro de téléphone invalide.";
    } else if (type === "siret" && inputValue && !/\d{14}$/.test(inputValue)) {
      errorMessage = "Le SIRET doit contenir chiffres.";
    }
   

    setError(errorMessage);
    // console.log(e?.target?.name)
    onChange(e);
  };

  return (
    <div className="input-wrapper">
      {label && (
        <label>
          {label} {required && <span>*</span>}
        </label>
      )}
      <input
        id={id}
        type={type === "siret" ? "text" : type} // Keep SIRET as text
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disabled={disabled}
      />
      {error && (
        <span className="error-message mt-8">
          <img src="/images/alert-circle.svg" className="arrow mr-8" alt="Arrow" />
          {error}
        </span>
      )}
    </div>
  );
};

export default TextInput;